/** xorshift32 — tiny, deterministic, seedable. State is a non-zero uint32. */
export function seedRng(seed: number): number {
  const s = seed >>> 0
  return s === 0 ? 0x9e3779b9 : s
}

/** Advances state; returns [nextState, float in [0,1)]. */
export function nextRandom(state: number): [number, number] {
  let x = state >>> 0
  x ^= x << 13
  x >>>= 0
  x ^= x >>> 17
  x ^= x << 5
  x >>>= 0
  return [x, x / 0x100000000]
}
